module.exports = __webpack_public_path__ + "static/media/denmark-icon.33bba71c.svg";